import apiClient from 'services/_infra/apiClient';
import { loginfo } from 'services/_infra/util/apiUsageLogger';

export async function fusionVerifyLicense(key, code) {
  loginfo();
  return await apiClient.post('/license/activate', {
    licenseKey: key,
    code: code,
  });
}

export async function fusionGetLicense(code) {
  try {
    return await apiClient.get(`/license?code=${code}`);
  } catch (error) {
    console.error('fusionFetchLicense failed.', error);
  }
}
